import { NgModule, CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
//import { MatFormFieldModule } from '@angular/material';
import { CustomDirectiveModule } from '@directive/custom-directive.module';
import { CustomEditorComponent } from './custom-editor.component';

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
   // MatFormFieldModule,
    MatInputModule,
    CustomDirectiveModule
  ],
  declarations: [
    CustomEditorComponent
  ],
  exports: [
    CustomEditorComponent
  ],
  bootstrap: [CustomEditorComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})

export class CustomEditorModule { }
